import { render, staticRenderFns } from "./newPie.vue?vue&type=template&id=4e1ed2e3&"
import script from "./newPie.vue?vue&type=script&lang=js&"
export * from "./newPie.vue?vue&type=script&lang=js&"
import style0 from "./newPie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports